// extracted by mini-css-extract-plugin
export default {"filters":"requestsTableFiltersForm_filters__VPWb2","searchInput":"requestsTableFiltersForm_searchInput__WM2vF"};